"use strict";

import angular from "angular";

import { ConfettiAnimation } from "../../../presentation/services/ConfettiAnimation/ConfettiAnimation";

class OneMillionImpactRealizedDialogCtrl {
    ConfettiAnimation = new ConfettiAnimation();
    engagementMission = {
        total: 0,
        missingImpact: 0
    };

    statusColorFireworks = {
        Bronze: "#B500D9",
        Prata: "#00D2D9",
        Ouro: "#FFB700"
    };
    constructor($mdDialog, locals, DSNDialogService, $state, $scope) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.$scope = $scope;
    }

    $onInit() {
        this.ConfettiAnimation.fireworks({
            colors: [
                this.statusColorFireworks[
                    this.locals?.engagement?.currentImpactLevel?.status ||
                        "Bronze"
                ]
            ],
            zIndex: 1000
        });
    }

    onDetails() {
        this.$mdDialog.cancel();

        const href = this.$state.href(
            "nucont.accounting.reporting-center.generateds",
            {
                progressLevelSideNav: true
            }
        );
        window.open(href, "_blank");
    }
}

angular
    .module("nucont.shared")
    .controller("OneMillionImpactRealizedDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        "$state",
        "$scope",
        OneMillionImpactRealizedDialogCtrl
    ]);
